<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="pr_code,pr_detail,pr_orispeccode,pr_spec"
        placeholder="输入物料编号、名称、规格、型号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/stock/in/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pd_inoutno}}</p>
            <p class="list-item-muted">{{item.pi_whname}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pr_detail}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.pi_status!='已审核'}"
            >
              {{item.pi_status}}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
      <add-button to="/stock/in_edit" />
    </div>

    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="pr_code,pr_detail,pr_orispeccode,pr_spec"
        placeholder="输入物料编号、名称、规格、型号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/stock/in_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ioc_code}}</p>
            <p class="list-item-muted">{{item.iocd_whname}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pr_detail}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ioc_status!='已审核'}"
            >
              {{item.ioc_status}}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isChange: false,
      listUrl: "/api/storage/prodinout/list",
      params: {
        caller: 'ProductInit'
      },
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
              mode: 'DETAIL',
              condition: "pi_class='RESERVEINITIALIZE'"
            },
            {
              value: 1,
              label: "待变更",
              mode: 'MAIN',
              condition: "ioc_statuscode!='AUDITED'"
            },
            {
              value: 2,
              label: "已变更",
              mode: 'MAIN',
              condition: "ioc_statuscode='AUDITED'"
            }
          ]
        }
      ],
    }
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 0
      this.listUrl = isChange ? '/api/storage/prodiodetailchange/list' : '/api/storage/prodinout/list'
      this.filters[0].name = isChange ? 'ProdIODetailChange.createTime' : 'pi_date'
      this.isChange = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
}
</script>